<script setup lang="ts">
import { instanceOfMedicalComponentTaskType, type TaskTypeBase } from '@/api/generator';
import { useSystemStore } from '@/stores/systemStore';
import InstructionsSection from './InstructionsSection.vue';
import ManufacturerSection from './ManufacturerSection.vue';
import ModuleInfo from './ModuleInfo.vue';

const { task } = defineProps<{
  task: TaskTypeBase;
}>();

const systemStore = useSystemStore();
</script>

<template>
  <ModuleInfo :data="task" />
  <template v-if="instanceOfMedicalComponentTaskType(task)">
    <div class="labeling-block">
      <InstructionsSection :instructions="systemStore.instructions" />
    </div>
    <div class="labeling-block">
      <ManufacturerSection :manufacturer="systemStore.manufacturer" />
    </div>
  </template>
</template>

<style lang="scss" scoped>
.labeling-block {
  margin-top: 32px;
}
</style>
